"use strict";

exports.__esModule = true;
exports["default"] = void 0;
/**
 * Returns empty run
 *
 * @return {Object} empty run
 */

var empty = function empty() {
  return {
    start: 0,
    end: 0,
    glyphIndices: [],
    glyphs: [],
    positions: [],
    attributes: {}
  };
};

var _default = empty;
exports["default"] = _default;